/**
 * Filtros de la grilla "Seguimiento de secuencias" (VEC-3474), para `GridFilterPanel`: vehículo, secuencia, estado y fechas de
 * inicio y de fin.
 *
 * El panel serializa con el nombre de cada campo (los de fecha, con las dos claves de su rango); `aParametrosDeApi` los traduce a los
 * parámetros que espera el endpoint `/formulario-secuencia-intento/grid` (secuencia y estado viajan como lista separada por coma).
 * Fecha inicio y fecha fin son un solo filtro cada una, con Desde y Hasta (tipo `rango` del panel), sin atajos.
 */

export const SEGUIMIENTO_INGRESOS_FILTROS_STORAGE_KEY = 'SeguimientoIngresosGrid_filtros';

// Arriba Vehículo, Secuencia y Estado (un tercio cada uno) y abajo Fecha inicio y Fecha fin (la mitad cada una): así las fechas se leen completas.
const ANCHO = { xs: 12, sm: 6, md: 4, lg: 4 };

// Cada rango son dos fechas en una celda: necesita más ancho que un campo común.
const ANCHO_RANGO = { xs: 12, sm: 12, md: 6, lg: 6 };

export const buildSeguimientoIngresosFilterFields = () => [
	{
		name: 'dominio',
		type: 'text',
		messageId: 'seguimientoIngresos.filtros.vehiculo.label',
		label: 'Vehículo',
		size: ANCHO,
	},
	{
		name: 'secuencia',
		type: 'multiselect',
		messageId: 'seguimientoIngresos.filtros.secuencia.label',
		label: 'Secuencia',
		size: ANCHO,
	},
	{
		name: 'estado',
		type: 'multiselect',
		messageId: 'seguimientoIngresos.filtros.estado.label',
		label: 'Estado',
		size: ANCHO,
	},
	{
		// Los rangos no viajan como tales: el panel los serializa a dos claves (desde y hasta); `aParametrosDeApi` las traduce.
		name: 'periodoInicio',
		type: 'rango',
		startName: 'fechaInicioDesde',
		endName: 'fechaInicioHasta',
		messageId: 'seguimientoIngresos.filtros.fecha_inicio.label',
		label: 'Fecha inicio',
		size: ANCHO_RANGO,
	},
	{
		name: 'periodoFin',
		type: 'rango',
		startName: 'fechaFinDesde',
		endName: 'fechaFinHasta',
		messageId: 'seguimientoIngresos.filtros.fecha_fin.label',
		label: 'Fecha fin',
		size: ANCHO_RANGO,
	},
];

/** Traduce lo que entrega el panel a los parámetros del endpoint, sin los vacíos. */
export const aParametrosDeApi = (query) => {
	const q = query || {};
	const mapa = {
		dominio: 'dominio',
		secuencia: 'secuencia_id',
		estado: 'estado',
		fechaInicioDesde: 'fecha_inicio_desde',
		fechaInicioHasta: 'fecha_inicio_hasta',
		fechaFinDesde: 'fecha_fin_desde',
		fechaFinHasta: 'fecha_fin_hasta',
	};
	const params = {};
	Object.keys(mapa).forEach((clave) => {
		const valor = q[clave];
		if (valor !== undefined && valor !== null && String(valor).trim() !== '') {
			params[mapa[clave]] = String(valor).trim();
		}
	});
	return params;
};
